import React from "react";


export default function SearchStockPage() {
    return <><h3>Stok Ara</h3></>
}
